import React, {Component} from 'react';
import {ControlLabel, Col, Row, Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import Select   from 'react-select'
   import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';
var statusMap = [
    {value:'Pending', label: 'Pending'},
    {value:'PendingPayout', label: 'Pending Payout'},
    {value:'Paid', label: 'Paid'},
]


export default class AdminUserTimeTrackingSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        var ContractorID = _.isUndefined(this.props.location.query.ContractorID) ? null : this.props.location.query.ContractorID
        var Markets =_.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
            var location = _.find(config.warehouseData, function (o) {
                return o.MarketName == item
            });
            if (location) {
                return {'value': item, 'label': location.MarketName}
            }
        })
        if (    _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom'])) > 0) {
            ContractorID =_.get(this.props.userReducer, 'contractor._id')
            if(Markets.length==0){
                Markets =[{value:_.get(this.props.userReducer, 'user.MarketName'), label:_.get(this.props.userReducer, 'user.MarketName')}]
            }
        }
        this.state = {
              filterOptions: {
                  ActivityTypes:  _.isUndefined(this.props.location.query.ActivityTypes) ? [  ] : _.isArray(this.props.location.query.ActivityTypes) ? _.map(this.props.location.query.Statuses, function (status) {
                      return _.find(config.timeTrackingActivityData, {name:status})
                  }) : [_.find(config.timeTrackingActivityData, {name:this.props.location.query.ActivityTypes})],
                  Statuses:  _.isUndefined(this.props.location.query.Statuses) ?  [] : _.isArray(this.props.location.query.Statuses) ? _.map(this.props.location.query.Statuses, function (status) {
                      return _.find(statusMap, {value:status})
                  }) : [_.find(statusMap, {value:this.props.location.query.Statuses})],
                 perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
               //   Type: _.isUndefined(this.props.location.query.Type) ? '' : this.props.location.query.Type,
                  ContractorID: ContractorID,
                  from:_.isUndefined(this.props.location.query.from) ? '' : moment(this.props.location.query.from),
                  to:_.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to),
                  Markets:Markets,
                  recordIDs:  _.isUndefined(this.props.location.query.recordIDs) ?  [] : _.isArray(this.props.location.query.recordIDs) ?  _.get(this.props.location.query, 'recordIDs', []) : [_.get(this.props.location.query, 'recordIDs')]

              }
        };

     };

    componentWillUnmount() {
         this.props.unmountSearchBox() /* to call search method after selecting tab again */
    }
    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.ContractorID) {
            queryParams.ContractorID = filterOptions.ContractorID;
        } else if(!config.checkAccessRights.call(this, {resources: ['time_tracking_view']})){
            queryParams.ContractorID =_.get(this.props, ['userReducer','contractor', '_id'])
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (filterOptions.from &&  moment(filterOptions.from, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.from = filterOptions.from.toISOString()
        }
        if (!_.isUndefined(filterOptions.ActivityTypes)) {
            queryParams.ActivityTypes = _.map(filterOptions.ActivityTypes, 'value')
        }
        if (!_.isUndefined(filterOptions.Statuses)) {
            queryParams.Statuses = _.map(filterOptions.Statuses, 'value')
        }else{
            queryParams.Statuses = ["Paid", "PendingPayout", "Pending"]
        }
        if (_.size(filterOptions.recordIDs) > 0) {
            queryParams.recordIDs = filterOptions.recordIDs
            queryParams.all= true;
        }
        if (_.size(filterOptions.Markets) > 0) {
            queryParams.Markets = _.map(filterOptions.Markets, 'value').join(',')
        }
        if (filterOptions.to &&  moment(filterOptions.to, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.to = filterOptions.to.toISOString()
        }
        // if (filterOptions.Type !== '') {
        //     queryParams.Type = filterOptions.Type;
        // }

         return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    onMarketsSelect(options) {
        var updateOptions = {...this.state.filterOptions, Markets: options};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }

    submitTimeLogsForReview() {
         var notValidRecordFound = false
        if (this.props.pending){
            return;
        }
        _.forEach(this.props.adminUsersData.selectedRecords, function (recordID, index) {
            var record = _.find(this.props.adminUsersData.data, function (item) {
                return item._id == recordID;
            })
            if (_.isUndefined(record)) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Selected time record not found. Please, select records again'
                });
                notValidRecordFound = true;
            }
            if (record.Status !== 'Pending') {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Only records in Pending status can be submitted'
                });
                notValidRecordFound = true;
            }
        }.bind(this))
        console.log('notValidRecordFound', notValidRecordFound  );
        if (notValidRecordFound) {

            return false;
        }

        this.setState({pending: true})
        var self = this;
        var methodData = {
            type: 'post',
            timeout: 50001,
            'endpoint': '/users_data_process',
            'not_display_success_message': true,
        };

        var params = {
            action: 'SubmitTimeLogsForReview',
            recordIDs: this.props.adminUsersData.selectedRecords,
            //     _.map(_.filter(this.props.adminUsersData.selectedRecords, item => {
            //     return _.includes(["PostingHome", "PostingWarehouse", "Fulfillment", "CustomerService", "Driving", "Meeting", "Other","PuttingAway"], item.ActivityType)
            // }), function (item) {
            //     return item._id
            // }, 0),
        }



        return this.props.makeRequest(params, methodData).then(res => {
            self.setState({pending: false})
            self.props.displayMessage({
                'messageCode': 'Time tracking data submitted'
            });
            this.props.search();

        }).catch(err => {
            this.setState({pending: false})
        });
    }
    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {

          var self = this;
         return (
            <div className="product-search-block">
                <Row className="show-grid">

                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Button className="btn btn-primary" onClick={this.props.onSelectAllRecordsChange}>
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>

                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                </Row>
                <Row  >

                    {  _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom'])) ==0 &&
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Select
                            tabIndex="0"
                            searchable={true}
                            selectedOptions
                            clearable={true}
                            placeholder="Users"
                            options={this.props.contractorsOptionsList}
                            // options={ this.props.foundContractorsList }
                            onChange={ (selectedOption) => {
                                console.log('selectedOption', selectedOption);

                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        ContractorID: selectedOption ? selectedOption.value : null,
                                    }
                                }, function () {
                                    this.props.search();
                                })
                            }}
                            value={this.state.filterOptions.ContractorID}
                        />

                    </Col>
                    }
                    <Col xs={6} sm={4} md={4} lg={3}className="top10">

                        <Select
                            tabIndex="0"
                            multi
                            placeholder="Activity"
                            clearable={true}
                            options={_.map(config.timeTrackingActivityData, item=>{
                                    return  {value:item.name,label:item.comment}
                            })}
                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        ActivityTypes: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.ActivityTypes}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3}className="top10">

                        <Select
                            tabIndex="0"
                            multi
                            placeholder="Status"
                            clearable={true}
                            options={statusMap}
                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Statuses: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Statuses}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                         <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      var isSameDate =  moment(this.state.filterOptions['from']).isSame(option, 'day')
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              from: option,
                                          }
                                      }, function () {
                                          if (!isSameDate) {
                                              this.props.search();
                                          }
                                      });
                                  }}
                                   inputProps={{ placeholder: 'From Started At' }}

                                  value={this.state.filterOptions.from}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                         <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      var isSameDate =  moment(this.state.filterOptions['to']).isSame(option, 'day')
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              to: option,
                                          }
                                      }, function () {
                                          if (!isSameDate) {
                                              this.props.search();
                                          }
                                      });
                                  }}
                                   inputProps={{ placeholder: 'To Started At' }}
                                  value={this.state.filterOptions.to}
                        />
                    </Col>
                    { config.checkAccessRights.call(this, {resources: ['time_tracking_view']}) &&
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            clearable={false}
                            placeholder="Location"
                            options={   _.map(config.warehouseData, item => {
                                return {value: item.MarketName, label: item.MarketName}
                            })}
                            onChange={this.onMarketsSelect.bind(this)}
                            value={self.state.filterOptions.Markets}
                        />
                    </Col>
                    }
                    <Col  xs={6} sm={4} md={4} lg={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                </Row>
                <Row>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.props.pending}  onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                    {_.get(this.props.adminUsersData, 'selectedRecords.0') &&
                    <Col md={3} xs={6} className="top10 pull-right">
                        <button className="btn btn-primary pull-right" disabled={this.props.pending} onClick={(event) => {
                            this.submitTimeLogsForReview()
                        }}
                                type="button">
                            Approve and Submit
                        </button>
                    </Col>
                    }
                </Row>

            </div>
        );

    }
}



